import firestoreServices from '../services/firestore.service';

const specialtiesFirestoreServices = firestoreServices('specialties');

export default {
  ...specialtiesFirestoreServices
};
